import React, { useState, useEffect } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { useCikContext } from '../../Context/CentralIndustrisContaxtProvider';
import logoblack from '../../assets/logoblack.png';
import './Nav.css';

function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const { navStatus, setNavStatus } = useCikContext();

  // Sticky nav on scroll
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 150);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={isScrolled ? 'nav-white' : ''} role="navigation" aria-label="Main navigation">
      <div className="nav__inner">

        {/* ── Logo ───────────────────────────────────── */}
        <div className="nav__logo">
          <AnchorLink href="#Home" aria-label="Home page">
            <img src={logoblack} alt="Central Industries Kandy logo" />
          </AnchorLink>
        </div>

        {/* ── Desktop Links ───────────────────────────── */}
        <div className="nav__links-wrapper">
          <ul className="nav__links" role="list">
            <li><AnchorLink href="#Home">Home</AnchorLink></li>
            <li><AnchorLink href="#Solutions">Services</AnchorLink></li>
            <li><AnchorLink href="#Products">Products</AnchorLink></li>
            <li><AnchorLink href="#About">About</AnchorLink></li>
            <li><AnchorLink href="#Gallery">Gallery</AnchorLink></li>
          </ul>
        </div>

        {/* ── CTA Button ────────────────────────────── */}
        <div className="nav__cta">
          <AnchorLink href="#Contact" className="btn btn-primary">
            Contact us
          </AnchorLink>
        </div>

        {/* ── Mobile Hamburger ─────────────────────── */}
        <div className="nav__hamburger">
          <button
            className={`nav__burger${navStatus ? ' nav__burger--open' : ''}`}
            onClick={() => setNavStatus(!navStatus)}
            aria-expanded={navStatus}
            aria-label="Toggle mobile menu"
          >
            <span className="nav__burger-line" aria-hidden="true" />
            <span className="nav__burger-line" aria-hidden="true" />
            <span className="nav__burger-line" aria-hidden="true" />
          </button>
        </div>

      </div>
    </nav>
  );
}

export default Nav;